import React from 'react';
import { OnboardingStepGate } from '../../components/OnboardingStepGate';
import { ROUTES_PATH } from '../../constants/Routes';
import { useOnboardingTools } from './useOnboardingTools';

interface OnboardingToolsGateProps {
  children: React.ReactNode;
  isExempt?: boolean;
}

export function OnboardingToolsGate({ children, isExempt }: OnboardingToolsGateProps) {
  const { status, isPollingCredits } = useOnboardingTools();

  return (
    <OnboardingStepGate
      status={status}
      stepPath={ROUTES_PATH.ONBOARDING.TOOLS}
      isPollingCredits={isPollingCredits}
      isExempt={isExempt}
    >
      {children}
    </OnboardingStepGate>
  );
}

export default OnboardingToolsGate;
